import React from 'react';
import { Helmet } from 'react-helmet';
import Header from '../../components/v3/Header';
import SEO from '../../components/seo';
import StatusPageExamples from '../../components/StatusPageExamples';
import Footer from '../../components/Footer';

const Page = () => (
  <div className="page">
    <Helmet htmlAttributes={{ theme: 'dark' }} />
    <SEO 
      title="Customer Showcase | Hyperping" 
      keywords={['customers', 'showcase', 'status page examples']} 
    />
    <Header />
    <StatusPageExamples />
    <br/>
    <br/>
    <Footer darkMode={true} />
  </div>
);

export default Page;
